import React from 'react';

  import Header from '../../Components/Header';
  
  import Sidebar from '../../Components/Sidebar';
  
  import PageHeader from '../../Components/PageHeader';
  
  import FormCreate from '../../Components/Page/Create/Category/FormCreate';
  
  const BottleCapacityCreate = () => {  
    return (
      <div className="flex">
        <Sidebar />
        <div className="content">
          <Header />
          <PageHeader
            title="Criar Novo(a) Capacidade"
            RigthActionButtonTitle="Voltar"
            RigthActionButtonRoute={'/bottle-capacities'}
          />
          <div>
            <FormCreate pageTitle={'/bottleCapacities'} accessor={'capacity'} pageItem={'bottleCapacity'} />
          </div>
        </div>
      </div>
    );
  };
  export default BottleCapacityCreate;
  